export enum AnalystOrganizationType {
    dgtlHealth = 'dgtlHealth',
    dgtlHealthBecauseOfDuration = 'dgtlHealthBecauseOfDuration',
    fysiologic = 'fysiologic',
    ksyosAnalyst = 'ksyosAnalyst',
    meddis = 'meddis',
    meddisBecauseOfAge = 'meddisBecauseOfAge',
}
